import axios from 'axios';
import querystring from 'querystring';
import {
    FETCH_LANG_DASHBOARD_SUCCESS,
} from '../constants/ActionTypes';

export const fetchLangDashboardSuccess = data => {
    return {
        type: FETCH_LANG_DASHBOARD_SUCCESS,
        payload: data
    }
}

export const fetchLangDashboard = (payload) => {
    const { company, language } = payload;
    let queryString = querystring.stringify({ company, language });
    
    return dispatch => {
        const url = `${process.env.REACT_APP_API_URL}language/dashboard?${queryString}`;
        axios.get(url, {headers: {"Authorization": `Bearer ${localStorage.getItem('x-access-token')}`}})
        .then(response => {
            let data = {
                noKpi: response.data.noKpi,
                activeCustomer: response.data.activeCustomer,
                active: response.data.active,
                customer: response.data.customer,
                clientVisit: response.data.clientVisit,
                visit: response.data.visit,
                salesStatistic: response.data.salesStatistic,
                mtdAmt: response.data.mtdAmt,
                qtdAmt: response.data.qtdAmt,
                ytdAmt: response.data.ytdAmt,
                salesOrderAmt: response.data.salesOrderAmt,
                backOrderAmt: response.data.backOrderAmt,
                cancelOrderAmt: response.data.cancelOrderAmt,
                chartMtdAmt: response.data.chartMtdAmt,
                target: response.data.target,
                currentMonth: response.data.currentMonth,
                currentMonthLastYear: response.data.currentMonthLastYear,
                salesNote: response.data.salesNote,
                invoiceAmt: response.data.invoiceAmt,
                rejectAmt: response.data.rejectAmt,
                returnAmt: response.data.returnAmt,
                customerGroup: response.data.customerGroup,
                productGroup: response.data.productGroup,
                salesTeam: response.data.salesTeam,
                chartInvoiceCreditNote: response.data.chartInvoiceCreditNote,
                creditNote: response.data.creditNote,
                invoice: response.data.invoice,
            }
            
            dispatch(fetchLangDashboardSuccess(data));
        })
        .catch(error => {
            //dispatch(showKpiMessage(error.response));
        })
    }
}

